/**
 * Polyfill for Array and String .at() methods.
 * Required for Vuetify 3 compatibility in older environments.
 */
declare global {
    interface Array<T> {
        at(index: number): T | undefined;
    }
    interface String {
        at(index: number): string | undefined;
    }
}

if (!Array.prototype.at) {
    Object.defineProperty(Array.prototype, "at", {
        value: function <T>(this: T[], n: number): T | undefined {
            // Convert to integer
            const i = Math.trunc(n) || 0;
            // Allow negative indexing
            const index = i < 0 ? i + this.length : i;
            // Out of bounds check
            if (index < 0 || index >= this.length) return undefined;
            return this[index];
        },
        writable: true,
        configurable: true,
    });
}
if (!String.prototype.at) {
    Object.defineProperty(String.prototype, "at", {
        value: function (this: string, n: number): string | undefined {
            const i = Math.trunc(n) || 0;
            const index = i < 0 ? i + this.length : i;
            if (index < 0 || index >= this.length) return undefined;
            return this.charAt(index);
        },
        writable: true,
        configurable: true,
    });
}

export {};
